module.exports = __webpack_public_path__ + "img/paypal-payment.68f6a621.png";